export enum StepId {
  appointment = 'appointment',
  change = 'change',
  confirm = 'confirm',
  customer = 'customer',
  questions = 'questions'
}

export interface StepModel {
  disableUserNavigation?: boolean;
  id: StepId;
  isCompleted: boolean;
  isDisabled: boolean;
  uri: string;
}
